import React, { useState, useEffect } from "react";
import chalkboardIcon from "../../assets/images/Icon awesome-chalkboard-teacher.png";
import liveTvIcon from "../../assets/images/Icon material-live-tv.png";
import schoolIcon from "../../assets/images/Icon ionic-md-school.png";
import styles from "./style.module.css";
import { ADMIN } from "../../services/auth";

function Cards({ liveSessionsCount }) {
  const initialCardData = [
    {
      icon: chalkboardIcon,
      count: 0, // Initially set count to 0
      label: "Total Teacher",
    },
    {
      icon: schoolIcon,
      count: 0, // Initially set count to 0
      label: "Total Students",
    },
    {
      icon: liveTvIcon,
      count: liveSessionsCount, // Initially set count to 0
      label: "Live Sessions",
    },
  ];

  const [cardData, setCardData] = useState(initialCardData);
  const [isDataFetched, setIsDataFetched] = useState(false);

  // console.log("liveSessionsCount", liveSessionsCount);

  useEffect(() => {
    // Fetch data from the API
    if (!isDataFetched) {
      ADMIN()
        .then((data) => {
          console.log(data);
          const updatedCardData = cardData.map((card) => {
            if (card.label === "Total Teacher") {
              return { ...card, count: data?.data?.data?.teachersCount || 0 };
            } else if (card.label === "Total Students") {
              return { ...card, count: data?.data?.data?.studentsCount || 0 };
            } else if (card.label === "Live Sessions") {
              return { ...card, count: liveSessionsCount };
            }
            return card;
          });
          setCardData(updatedCardData);
          setIsDataFetched(true);
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
  }, [cardData, isDataFetched, liveSessionsCount]);

  return (
    <>
      {/* Desktop Version Cards */}
      <div className="container p-0 mb-4 m-0">
        <div className="row">
          {false
            ? "Loading"
            : cardData?.length
            ? cardData.map((card, index) => (
                <div
                  className="col-lg-4 col-md-6 col-sm-6 col-12 py-2"
                  key={index}
                >
                  <div
                    className={`${styles.cardBgColor} ${styles.cardShadow} card`}
                  >
                    <div className="card-body" style={{ padding: "1.6rem" }}>
                      <div className="d-flex flex-wrap align-items-center">
                        <div
                          className={`align-self-center bg-white border rounded-circle ${styles.p_16} me-sm-2 shadow-sm`}
                        >
                          <div className="icon">
                            <img src={card.icon} alt="" style={{ width: 30 }} />
                          </div>
                        </div>
                        <div className="flex-grow-1 align-self-center d-flex ">
                          <span
                            className="m-0 h2 pl-2"
                            style={{ fontWeight: "600" }}
                          >
                            {card.count}
                          </span>
                          <span
                            className={`font-weight-bold align-self-center pl-3 pt-2 ${styles.fontSize_14}`}
                          >
                            {card.label}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            : "No data found"}
        </div>
      </div>
    </>
  );
}

export default Cards;
